import { z } from 'zod';

export const createProjectMilestoneSchema = z.object({
  title: z.string().trim().min(1).max(200),
  dueDate: z.string().datetime().optional(),
});
export type CreateProjectMilestoneInput = z.infer<typeof createProjectMilestoneSchema>;

export const updateProjectMilestoneSchema = z.object({
  title: z.string().trim().min(1).max(200).optional(),
  dueDate: z.string().datetime().nullable().optional(),
  /** Setzen/Zurücksetzen des Erreicht-Zeitpunkts (null = wieder offen). */
  reachedAt: z.string().datetime().nullable().optional(),
});
export type UpdateProjectMilestoneInput = z.infer<typeof updateProjectMilestoneSchema>;

export const projectMilestoneResponseSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  title: z.string(),
  dueDate: z.string().datetime().nullable(),
  reachedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type ProjectMilestoneResponse = z.infer<typeof projectMilestoneResponseSchema>;
